import { peek, selector } from 'lib/selectors'
import { StateInterface } from 'types/state'

const notifications = (state: StateInterface) => state.notifications
export const notificationsSelector = selector(notifications, peek('list'))
export const notificationsMetaSelector = selector(notifications, peek('meta'))
export const unreadNotificationsCount = selector(notifications, peek('unreadNotifications'))
